import { DirectiveBinding } from 'vue';
import { addTask, removeTask } from './state';

interface DirectiveElement extends Element {
    componentId: number;
}

export default {
    name: 'scroll',
    mounted(el: DirectiveElement, binding: DirectiveBinding) {
        el.componentId = addTask(binding.value[0] as any, binding.value[1] as string);
    },
    beforeUnmount(el: DirectiveElement, binding: DirectiveBinding) {
        removeTask(el?.componentId?.toString(), binding.value?.[1]);
    },
};
